module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_2/2-4-718c3c89db4314c235c869be63b761c7.png";